"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
var _customerCoupon = require("@/api/activity/customerCoupon");
var _couponCode = _interopRequireDefault(require("@/api/activity/couponCode.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'customerCouponeRecordUsed',
  emits: [],
  props: {
    issueCode: {
      type: String,
      default: null
    }
  },
  watch: {
    issueCode: {
      immediate: true,
      handler: function handler(newissueCode, oldissueCode) {
        // 避免初始化时的不必要调用
        if (newissueCode && newissueCode != '' && newissueCode != 'null') {
          this.searchForm.issueCode = newissueCode;
          this.getRecordUsedList();
        } else {
          this.getRecordUsedList();
        }
        ;
        // this.getShopList();
      }
    }
  },
  data: function data() {
    return {
      shoplist: [],
      // 搜索表单
      searchForm: {
        cardNo: '',
        mobileNo: '',
        userName: '',
        issueCode: '',
        couponId: '',
        couponName: '',
        orderNo: '',
        verifyStatus: null,
        sendStatus: null,
        startTime: '',
        endTime: '',
        page: 1,
        limit: 10,
        total: 0
      },
      // 日期范围
      dateRange: [],
      // 数据列表
      recordUsedList: [],
      loading: false,
      downloadLoading: false
    };
  },
  methods: {
    getShopList: function getShopList() {
      var _this = this;
      _couponCode.default.getStoreList().then(function (res) {
        _this.shoplist = res;
      });
    },
    // 获取数据列表
    getRecordUsedList: function getRecordUsedList() {
      var _this2 = this;
      this.loading = true;
      (0, _customerCoupon.getCouponSendInfoUsed)(this.searchForm).then(function (res) {
        if (res.code == 200) {
          _this2.recordUsedList = res.records || [];
          _this2.searchForm.total = res.total;
        } else {
          _this2.$message.error(res.msg || '查询失败');
        }
      }).finally(function () {
        _this2.loading = false;
      });
    },
    // 搜索
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getRecordUsedList();
    },
    // 导出
    handleExport: function handleExport() {
      var _this3 = this;
      this.downloadLoading = true;
      (0, _customerCoupon.getCouponSendInfoUsedExport)(this.searchForm).then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.ms-excel'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '券领取明细.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).finally(function () {
        _this3.downloadLoading = false;
      });
    },
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
      this.getRecordUsedList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getRecordUsedList();
    },
    // 处理日期范围变化
    handleDateChange: function handleDateChange(val) {
      if (val && val.length === 2) {
        this.searchForm.startTime = val[0];
        this.searchForm.endTime = val[1];
      } else {
        this.searchForm.startTime = '';
        this.searchForm.endTime = '';
      }
    },
    // 获取核销状态类型
    getVerifyStatusType: function getVerifyStatusType(status) {
      switch (status) {
        case 0:
          return 'warning';
        case 1:
          return 'success';
        default:
          return '';
      }
    },
    // 获取核销状态文本
    getVerifyStatusText: function getVerifyStatusText(status) {
      switch (status) {
        case 0:
          return '未核销';
        case 1:
          return '已核销';
        default:
          return '';
      }
    },
    // 获取发放状态类型
    getSendStatusType: function getSendStatusType(status) {
      switch (status) {
        case 0:
          return 'info';
        case 1:
          return 'success';
        case 2:
          return 'danger';
        default:
          return '';
      }
    },
    // 获取发放状态文本
    getSendStatusText: function getSendStatusText(status) {
      switch (status) {
        case 0:
          return '发放中';
        case 1:
          return '已发放';
        case 2:
          return '发放失败';
        default:
          return '';
      }
    },
    // 格式化日期
    formatDate: function formatDate(date) {
      if (!date) return '';
      var d = new Date(date);
      var year = d.getFullYear();
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      var hours = String(d.getHours()).padStart(2, '0');
      var minutes = String(d.getMinutes()).padStart(2, '0');
      var seconds = String(d.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    }
  }
};